import { Controller } from "@hotwired/stimulus"
import { start } from "@popperjs/core"
import Tribute from "tributejs"


// Connects to data-controller="mentions"
export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    document.addEventListener("trix-initialize", () => this.initializeTribute())
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }

  initializeTribute() {
    this.editor = this.fieldTarget.editor
    this.tribute = new Tribute({
      collection: [{
        trigger: "@",
        allowSpaces: true,
        // lookup: "key",
        // menuShowMinLength: 1,
        // menuItemLength: 10,
        // values: [
        //   { key: "John Doe", value: "johndoe" },
        //   { key: "Jane Doe", value: "janedoe" }
        // ]
        lookup: "name",
        menuItemTemplate: function (item) {
          return `<img src="${item.original.avatar}" height="18px" width="18px">${item.string}`
        },
        values: this.fetchUsers
      }]
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", (e) => this.replaced(e))


  }

  fetchUsers(text, callback) {
    fetch(`/mentions.json?query=${text}`)
      .then(response => response.json())
      .then(users => callback(users))
      .catch(error => callback([]))
  }

  replaced(e) {
    let mention = e.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }

  _pasteHtml(html, startPos, endPos) {
    let position = this.editor.getPosition()
    //this.editor.setSelectedRange([position - endPos, position])
    this.editor.setSelectedRange([position - endPos + startPos, position + 1])
    this.editor.deleteInDirection("backward")
  }

  // replaced(event) {
  //   let mention = event.detail.item.original

  //   this.editor.insertHTML(`${mention.key}`)
  // }

  // _pasteHtml(html, startPos, endPos) {
  //   let range = this.editor.getSelectedRange()
  //   let position = range[0]
  //   let length = endPos - startPos

  //   this.editor.setSelectedRange([position - length, position])
  //   this.editor.deleteInDirection("backward")
  // }
}
